import React, { useEffect, useState } from 'react';
import { Select } from '../../../components/ui/Input';
import { fornecedoresApi } from '../../../api/fornecedores';

export default function DadosComerciaisTab({ form, onChange }) {
  const [fornecedores, setFornecedores] = useState([]);

  useEffect(() => { fornecedoresApi.listar().then(setFornecedores).catch(() => {}); }, []);

  const opcoes = [{ value: '', label: '(sem fornecedor padrão)' }, ...fornecedores.map(f => ({ value: f.id, label: f.nome_fantasia }))];

  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 6 }}>
      <Select label="Fornecedor Padrão" options={opcoes} value={form.fornecedor_padrao_id || ''} onChange={e => onChange('fornecedor_padrao_id', e.target.value || null)} />
    </div>
  );
}
